






















































































import { Vue, Component, Prop } from "vue-property-decorator";
import SelectEntity from "@/components/form/SelectEntity.vue";
import { ExpulsionOrder as IExpulsionOrder } from "@/api/models/expulsion-order";
import { CourseListenerUnion as ICourseListener } from "@/api/models/course-listener-union";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { CourseListenersUnionList as ICourseListenersList } from "@/api/models/course-listeners-union-list";
import expulsionListeners, {
  ExpulsionOrdersListeners
} from "@/getinfo-api/expulsion-listeners";
import { Employee as IEmployee } from "@/api/models/employee";
import { ExpulsionOrderEdit as IExpulsionOrderEdit } from "@/api/models/expulsion-order-edit";
import api, { courseApi } from "@/getinfo-api";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import ListenerTable from "@/components/tables/ListenerTable.vue";
import { getCurrentCompanyId } from "@/plugins/roles";
import Modal from "@/components/form/Modal.vue";
import { uniqBy } from "lodash";

@Component({
  components: {
    Modal,
    ListenerTable,
    SelectEntity,
    CustomDatepicker
  }
})
export default class expulsionOrderFormEdit extends Vue {
  @Prop() expulsionInfo!: IExpulsionOrder;
  isLoading: boolean = false;
  signedAt?: Date;
  courses: Array<string> = [];
  educationStartedAt?: Date;
  educationFinishedAt?: Date;
  listeners: Array<ICourseListener> = [];
  selectedListeners: Array<string> = [];
  showSpinner: boolean = false;
  activeListeners?: Array<ICourseListener> = [];
  listenersCount: number = 0;
  formedAt!: Date | undefined;
  allListeners: Array<ICourseListener> = [];
  employees!: Array<IEmployee> | undefined;
  limit: number = 1000;
  number!: string;
  courseTitle: string = "";

  data() {
    return {
      number: undefined,
      signedAt: undefined,
      educationStartedAt: undefined,
      educationFinishedAt: undefined,
      formedAt: undefined,
      employees: undefined
    };
  }

  deleteExpulsion() {
    api.ExpulsionOrderApi._delete(this.expulsionInfo?.id)
      .then(() => {
        this.$router.push({ name: "expulsionList" });
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  getListeners(list: Array<ICourseListener>) {
    this.selectedListeners = list.map(el => el.id);
  }

  getStatus(listener: ICourseListener) {
    let status: string = "";
    if (listener.status === "success")
      status = this.$tc(this.$translate.Successful);
    if (listener.status === "learning")
      status = this.$tc(this.$translate.Training);
    if (listener.status === "not_success")
      status = this.$tc(this.$translate.CompletedUnsuccessfully);
    return status;
  }

  getExpulsionListeners(offset: number = 0) {
    this.allListeners = [];
    this.showSpinner = true;
    let params: ExpulsionOrdersListeners = {
      //@ts-ignore
      courseId: this.expulsionInfo?.courseId,
      hasProtocol: false,
      offset: offset,
      limit: this.limit
    };
    expulsionListeners(params)
      .then((res: { data: ICourseListenersList }) => {
        this.listenersCount = res.data.count;
        res.data.listeners.forEach((el: ICourseListener) => {
          this.allListeners.push(el);
        });
        this.filterListenersByDate();
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.showSpinner = false;
      });
  }

  filterListenersByDate() {
    let formDate = this.educationStartedAt;
    this.allListeners?.forEach(el => {
      let listenersStarted = new Date(el.createdAt);
      listenersStarted.setHours(0, 0, 0, 0);
      if (listenersStarted.toDateString() === formDate?.toDateString()) {
        this.listeners.push(el);
      }
      this.listeners = uniqBy(this.listeners, "id");
    });
  }

  getActiveEnrollmentListeners() {
    this.activeListeners = [];
    this.activeListeners = this.expulsionInfo
      ? this.expulsionInfo.listeners
      : [];
    this.activeListeners?.forEach(el => {
      this.listeners.unshift(el);
      this.selectedListeners.push(el.id);
    });
  }

  get selectedCompany() {
    return getCurrentCompanyId();
  }

  get selectedCourses() {
    return this.expulsionInfo?.courseId;
  }

  created() {
    this.getActiveEnrollmentListeners();
    this.getExpulsionListeners();
    this.educationStartedAt = this.expulsionInfo.educationStartedAt;
    this.educationFinishedAt = this.expulsionInfo.educationFinishedAt;
    this.signedAt = this.expulsionInfo.signedAt;
    this.number = this.expulsionInfo.number;
    this.formedAt = this.expulsionInfo.formedAt;

    if (this.expulsionInfo.courseVersion === "v2") {
      courseApi.Course.getCourse(this.expulsionInfo.courseId).then(
        ({ data }) => {
          this.courseTitle = data.title;
        }
      );
    }
  }

  expulsionEdit() {
    if (this.formedAt) {
      const edit: IExpulsionOrderEdit = {
        courseId: this.expulsionInfo.courseId,
        fileIds: this.expulsionInfo.files?.map((el: any) => el.id),
        formedAt: this.formedAt,
        ownerId: this.expulsionInfo.ownerId,
        number: this.number,
        signedAt: this.signedAt,
        educationStartedAt: this.educationStartedAt,
        educationFinishedAt: this.educationFinishedAt,
        listeners: this.selectedListeners
      };
      this.isLoading = true;
      api.ExpulsionOrderApi.edit(this.expulsionInfo.id, edit)
        .then((res: { data: IExpulsionOrder }) => {
          this.$router.push({
            name: "expulsionOrder",
            params: { expulsionId: res.data.id }
          });
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
}
